import { Component, Input } from '@angular/core';

@Component({
  selector: 'stepperControl',
  templateUrl: './stepper-control.component.html',
  styleUrls: ['./stepper-control.component.scss']
})
export class StepperControlComponent {
  @Input() type: string = 'horizontal'; 
  @Input() data: any[];
}
